import React, { useState } from 'react';
import { Plus, Trash2, Upload } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import InputMonto from '../../components/InputMonto';
import SelectorAviso from '../../components/SelectorAviso';

const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const mesActual = () => new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 7);

// Los números que cargamos de cada plataforma
const CAMPOS = [
  ['inversion', 'Inversión', true],
  ['impresiones', 'Impresiones / alcance', false],
  ['clics', 'Clics', false],
  ['resultados', 'Resultados', false],
];

/* Carga del reporte del mes: el documento, los números y la conclusión */
export default function ModalReporte({ reporte, cliente_id, contrato_id, plataformas = [], onClose, onListo }) {
  const inicial = reporte || {
    periodo: mesActual(), titulo: '', conclusion: '',
    metricas: { plataformas: plataformas.map(n => ({ nombre: n })), destacados: [] },
  };
  const [r, setR] = useState({ ...inicial, metricas: inicial.metricas || { plataformas: [], destacados: [] } });
  const [archivo, setArchivo] = useState(null);
  const [canal, setCanal] = useState('portal');
  const [guardando, setGuardando] = useState(false);

  const plats = r.metricas.plataformas || [];
  const dest = r.metricas.destacados || [];
  const setMet = (campo, valor) => setR({ ...r, metricas: { ...r.metricas, [campo]: valor } });
  const setPlat = (i, campo, v) => setMet('plataformas', plats.map((p, j) => (j === i ? { ...p, [campo]: v } : p)));
  const setDest = (i, campo, v) => setMet('destacados', dest.map((d, j) => (j === i ? { ...d, [campo]: v } : d)));

  const inversion = plats.reduce((a, p) => a + Number(p.inversion || 0), 0);
  const resultados = plats.reduce((a, p) => a + Number(p.resultados || 0), 0);

  const guardar = async (publicar) => {
    if (!r.periodo) return toast.error('Elegí el período');
    setGuardando(true);
    try {
      const cuerpo = {
        cliente_id, contrato_id, periodo: r.periodo, titulo: r.titulo || '', conclusion: r.conclusion || '',
        plataformas: plats.filter(p => p.nombre), destacados: dest.filter(d => d.label),
      };
      const { data } = r.id ? await api.put('/agency/reportes-campana/' + r.id, cuerpo)
        : await api.post('/agency/reportes-campana', cuerpo);
      const id = data.id || r.id;
      if (archivo) {
        const fd = new FormData(); fd.append('documento', archivo);
        await api.post(`/agency/reportes-campana/${id}/documento`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      }
      if (publicar) {
        const { data: pub } = await api.post(`/agency/reportes-campana/${id}/publicar`, { notificar: canal });
        toast.success(pub.destinos && pub.destinos.length ? 'Publicado · le avisamos a ' + pub.destinos.join(', ') : 'Publicado');
      } else toast.success('Guardado');
      onListo && onListo();
    } catch (err) { toast.error(err.response?.data?.error || 'No se pudo guardar'); }
    finally { setGuardando(false); }
  };

  const [anio, mes] = r.periodo.split('-');
  const etiqueta = { fontSize: 11, color: 'var(--text-muted)' };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 660 }}>
        <h2>{r.id ? 'Editar reporte' : 'Cargar reporte del mes'}</h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12 }}>
          <div className="form-group"><label>Mes</label>
            <select value={Number(mes)} onChange={e => setR({ ...r, periodo: `${anio}-${String(e.target.value).padStart(2, '0')}` })}>
              {MESES.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select></div>
          <div className="form-group"><label>Año</label>
            <input type="number" value={anio} onChange={e => setR({ ...r, periodo: `${e.target.value}-${mes}` })} /></div>
          <div className="form-group" style={{ gridColumn: 'span 2' }}><label>Título (opcional)</label>
            <input value={r.titulo || ''} onChange={e => setR({ ...r, titulo: e.target.value })} placeholder="Reporte de septiembre" /></div>
        </div>

        <h3 style={{ fontSize: 14, fontWeight: 700, margin: '6px 0 4px' }}>Números del mes</h3>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>
          De acá salen los gráficos del portal. Cargá solo lo que tenga sentido en cada plataforma.
        </div>
        {plats.map((p, i) => (
          <div key={i} style={{ border: '1px solid var(--border)', borderRadius: 10, padding: 12, marginBottom: 10 }}>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <input value={p.nombre || ''} onChange={e => setPlat(i, 'nombre', e.target.value)} placeholder="Google Ads" style={{ fontWeight: 600 }} />
              <button type="button" className="btn btn-ghost btn-sm" onClick={() => setMet('plataformas', plats.filter((_, j) => j !== i))}><Trash2 size={14} /></button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 8 }}>
              {CAMPOS.map(([k, label, esMonto]) => (
                <div key={k}>
                  <label style={etiqueta}>{label}</label>
                  {esMonto
                    ? <InputMonto value={p[k] ?? ''} onChange={v => setPlat(i, k, v)} />
                    : <input type="number" value={p[k] ?? ''} onChange={e => setPlat(i, k, e.target.value)} />}
                </div>
              ))}
            </div>
          </div>
        ))}
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => setMet('plataformas', [...plats, { nombre: '' }])}>
          <Plus size={14} /> Agregar plataforma
        </button>

        {(inversion > 0 || resultados > 0) && (
          <div style={{ fontSize: 13, marginTop: 12, color: 'var(--text-secondary)' }}>
            Total del mes: <b>${inversion.toLocaleString('es-AR')}</b>
            {resultados > 0 && <> · {resultados} resultados · <b>${Math.round(inversion / resultados).toLocaleString('es-AR')}</b> por resultado</>}
          </div>
        )}

        <h3 style={{ fontSize: 14, fontWeight: 700, margin: '18px 0 4px' }}>Destacados (opcional)</h3>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>Tres o cuatro datos que quieras resaltar arriba del reporte.</div>
        {dest.map((x, i) => (
          <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
            <input value={x.label || ''} onChange={e => setDest(i, 'label', e.target.value)} placeholder="Consultas por WhatsApp" style={{ flex: '1 1 180px' }} />
            <input value={x.valor || ''} onChange={e => setDest(i, 'valor', e.target.value)} placeholder="75" style={{ maxWidth: 110 }} />
            <input value={x.variacion || ''} onChange={e => setDest(i, 'variacion', e.target.value)} placeholder="+18%" style={{ maxWidth: 90 }} />
            <button type="button" className="btn btn-ghost btn-sm" onClick={() => setMet('destacados', dest.filter((_, j) => j !== i))}><Trash2 size={14} /></button>
          </div>
        ))}
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => setMet('destacados', [...dest, { label: '', valor: '', variacion: '' }])}>
          <Plus size={14} /> Agregar destacado
        </button>

        <div className="form-group" style={{ marginTop: 18 }}><label>Conclusión para el cliente</label>
          <textarea rows={3} value={r.conclusion || ''} onChange={e => setR({ ...r, conclusion: e.target.value })}
            style={{ fontFamily: 'inherit', fontSize: 13 }} placeholder="Bajamos el costo por consulta un 18% respecto de agosto..." /></div>

        <div className="form-group"><label>Documento del reporte</label>
          <input type="file" accept="application/pdf,text/html" onChange={e => setArchivo(e.target.files[0])} />
          {r.documento_url && !archivo && (
            <div style={{ fontSize: 12, marginTop: 6 }}><Upload size={12} /> Ya tiene uno · <a href={r.documento_url} target="_blank" rel="noopener noreferrer">verlo</a></div>
          )}
        </div>

        <SelectorAviso value={canal} onChange={setCanal} etiqueta="Al publicar, avisarle" />

        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 8 }}>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn btn-secondary" onClick={() => guardar(false)} disabled={guardando}>Guardar borrador</button>
          <button type="button" className="btn btn-primary" onClick={() => guardar(true)} disabled={guardando}>Publicar</button>
        </div>
      </div>
    </div>
  );
}
